import clsx from "clsx";
import React from "react";
import styles from "./PenaltiesInfographic.module.scss";
import { PenaltiesInfographicIconStep } from "./PenaltiesInfographicStep";

interface PenaltiesInfographicProps {
  startLabel: string;
  endLabel: string;
  className?: string;
  administrativeFeeDisclaimer?: string;
  refundableMobileLabel?: string;
}

export const PenaltiesInfographic: React.FC<
  React.PropsWithChildren<PenaltiesInfographicProps>
> = ({
  children,
  startLabel,
  endLabel,
  administrativeFeeDisclaimer,
  refundableMobileLabel,
  className
}) => {
  return (
    <div>
      <div className={clsx(styles.container, className)}>
        <PenaltiesInfographicIconStep
          iconName="user-booking"
          label={startLabel}
        />
        <div className={styles.steps}>{children}</div>
        <PenaltiesInfographicIconStep
          iconName="ship-lateral"
          label={endLabel}
        />
      </div>
      {refundableMobileLabel && (
        <div className={styles.refundableMobileLabel}>
          {refundableMobileLabel}
        </div>
      )}
      {administrativeFeeDisclaimer && (
        <div className={styles.administrativeFeeDisclaimer}>
          {administrativeFeeDisclaimer}
        </div>
      )}
    </div>
  );
};
